$(function() {
  
  if($('.total-price .price').length){
    var prezzo_pulito = $('.total-price .price').html().trim();
    prezzo_pulito = prezzo_pulito.replace("€","");
    prezzo_pulito = prezzo_pulito.replace(",",".");

    var costo_spedizione = 4.90;
    if(prezzo_pulito > 29.9){
      costo_spedizione = 0;
    }
    costo_spedizione = costo_spedizione.toFixed(2);
    costo_spedizione = costo_spedizione.replace(".", ",");
    
    $('#spedizione').html('€'+costo_spedizione);
  }
  
  $('body').on('DOMSubtreeModified', '.total-price .price', function(){
    
    var prezzo_pulito = $('.total-price .price').html().trim();
    prezzo_pulito = prezzo_pulito.replace("€","");
    prezzo_pulito = prezzo_pulito.replace(",",".");
    
    var costo_spedizione = 4.90;
    if(prezzo_pulito > 29.9){
      costo_spedizione = 0;
    }
    costo_spedizione = costo_spedizione.toFixed(2);
    costo_spedizione = costo_spedizione.replace(".", ",");
    
    $('#spedizione').html('€'+costo_spedizione);
    
  });
  
  
  
  /*$( ".quantity .extra .inc, .quantity .extra .dec" ).on( "click", function(event) {
    
    event.preventDefault();
    
    //alert( $( this ).text() );
    //$("#"+$(this).parent().parent().parent().parent().attr('id')+" .price").trigger("change");
    
    console.log("vaiii"+quantity);
    
    //var Price = $(this).parents('.product-details').find('.price');
    var quantity = parseInt(jQuery(this).parent().find('.number').val())+1;
    
    
    
    //var aa = Shopify.formatMoney($("#"+$(this).parent().parent().parent().parent().attr('id')+" .price").data('price'), window.money_format );
    
    var tot = $("#"+$(this).parent().parent().parent().parent().attr('id')+" .price").data('price')*quantity;
    
    tot = Shopify.formatMoney(tot, window.money_format);
    
    
    $("#"+$(this).parent().parent().parent().parent().attr('id')+" p.price").html(tot).trigger("change");
    
    
    //$("#"+$(this).parent().parent().parent().parent().attr('id')+" #updates_"+$(this).parent().parent().parent().parent().attr('id')).trigger("change");
    $("#"+$(this).parent().parent().parent().parent().attr('id')+" .quantity .update").trigger("click");
    
    
    console.log(quantity+"QUIII"+tot);
    //console.log(tot+"---"+aa+"vaiii"+Price.html()+"||||"+quantity);
    
  });*/
  
  
  
  var tipoDoc = $("#tipoDocumento input[type='radio']:checked").val();
  console.log("QUIII"+tipoDoc);
  
  if(tipoDoc == 'Ricevuta'){
  	//$('#boxRicevuta').show();
  }
  else{
  	//$('#boxRicevuta').hide();
  }
  
  if(tipoDoc == 'Ricevuta per detrazione fiscale'){
  	$('#boxRicevutaDetrazioneFiscale').show();
  }
  else{
  	$('#boxRicevutaDetrazioneFiscale').hide();
  }
  
  if(tipoDoc == 'Fattura'){
  	$('#boxFattura').show();
  }
  else{
  	$('#boxFattura').hide();
  }
  
  
  
  $('#tipoDocumento input').on('change', function() {
    //alert($('input:checked', '#tipoDocumento').val()); 
    
    if($('input:checked', '#tipoDocumento').val() == 'Ricevuta'){
      //$('#boxRicevuta').show();
      $('#partita-iva').removeAttr('required');
      $('#codice-fiscale').removeAttr('required');
      $('#partita-iva').val('');
      $('#codice-fiscale').val('');
    }
    else{
      //$('#boxRicevuta').hide();
    }

    if($('input:checked', '#tipoDocumento').val() == 'Ricevuta per detrazione fiscale'){
      $('#boxRicevutaDetrazioneFiscale').show();
      $('#codice-fiscale').attr('required', 'required');
      $('#partita-iva').removeAttr('required');
      $('#partita-iva').val('');
    }
    else{
      $('#boxRicevutaDetrazioneFiscale').hide();
      $('#codice-fiscale').val('');
    }

    if($('input:checked', '#tipoDocumento').val() == 'Fattura'){
      $('#boxFattura').show();
      $('#partita-iva').attr('required', 'required');
      $('#codice-fiscale').removeAttr('required');
      $('#codice-fiscale').val('');
    }
    else{
      $('#boxFattura').hide();
      $('#partita-iva').val('');
    }
    
  });
  
  
  
});



/*$(document).ready(function(){
    $("input[name='updates[]']").on('input', function() {
      $( "input[name='update']" ).trigger( "click" );
    });
  });*/